import { createContext, Dispatch, SetStateAction } from "react";

// Lets components rendered inside CedarShellLayout's content area (e.g. DashboardCard's Open
// button) collapse the sidenav, without threading the state through every intermediate page.
export const CedarShellSidenavContext = createContext<{
  collapsed: boolean;
  setCollapsed: Dispatch<SetStateAction<boolean>>;
}>({
  collapsed: false,
  setCollapsed(): void {},
});
